import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { convertDate } from "../../../helpers/Utils";
import { TOKENS } from "../constants/figmaTokens";
import { formatMoney } from "../utils/money";

const HEADER_SX = {
  fontSize: 12,
  fontWeight: 500,
  textTransform: "uppercase",
  color: TOKENS.onSurfaceSecondary,
};

export default function GrnsSection({ grns = [] }) {
  if (grns.length === 0) return null;
  return (
    <Card
      sx={{
        bgcolor: TOKENS.surfaceDefault,
        borderRadius: "8px",
        boxShadow: "none",
        p: "24px",
      }}
    >
      <Box display="flex" alignItems="center" gap="8px" mb={2}>
        <Typography sx={{ fontSize: 16, fontWeight: 700, lineHeight: "24px" }}>
          GRNs
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            lineHeight: "16px",
            color: TOKENS.onSurfaceSecondary,
          }}
        >
          ({grns.length})
        </Typography>
      </Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={HEADER_SX}>GRN ID</TableCell>
              <TableCell sx={HEADER_SX}>GRN Date</TableCell>
              <TableCell align="right" sx={HEADER_SX}>
                GRN Value
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {grns.map((g, idx) => (
              <TableRow key={g.grn_id || idx}>
                <TableCell sx={{ fontSize: 14, lineHeight: "20px" }}>
                  {g.grn_id || "—"}
                </TableCell>
                <TableCell sx={{ fontSize: 14, lineHeight: "20px" }}>
                  {g.grn_date ? convertDate(g.grn_date) : "—"}
                </TableCell>
                <TableCell align="right" sx={{ fontSize: 14, fontWeight: 500 }}>
                  {g.grn_value != null ? formatMoney(g.grn_value) : "—"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
